<template>
    <div class="d-inline-block notranslate">
        <span>{{formattedTotal}}</span>
    </div>
</template>

<script>
import { getExchangedAmount } from '../../bu/CurrencyUtils';
import { calculateBillableUnits } from '../../bu/RentableUtils';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { localizedAmount } from '../../currency';

export default {
    props: {
        item: { type: Object, required: false },
        spec: { type: Object, required: false },
        count: { default: 1},
        start: { type: String, required: false },
        end: { type: String, required: false },
        orderItem: { type: Object, required: false },
        cartItem: { type: Object, required: false },
        provider: { type: Object, required: true },
        // 這是給 order item 配合顯示用，因為 order item 不需要換算，直接使用 order.currency
        forceCurrency: { type: String, default: null },
    },
    computed: {
        ...mapGetters({
            currency: 'currencies/currency',
            currencyRateMap: 'currencies/currencyRateMap',
            currencyOptions: 'currencies/currencyOptions',
        }),
        formattedTotal() {
            if (this.cartItem && this.cartItem.failToCalculatePrice) {
                return this.$t('message.please_select_booking_date_time_to_calculate');
            }

            const cartItem = (this.cartItem && this.cartItem.isSplitted) ? this.cartItem : null;
            if (this.cartItem?.appliedPricingRule && !this.cartItem.isSplitted) {
                return this.getExchangedAmount(this.cartItem.total);
            }

            const isRenting = (this.orderItem || cartItem) ? (this.orderItem || cartItem).is_renting : this.item.is_renting;
            const buyable = this.orderItem || cartItem || this.spec || this.item;
            if (isRenting) {
                if (!this.start || !this.end) {
                    return this.$t('message.please_select_booking_date_time_to_calculate');
                }
                const translationKey = `price_per_${buyable.renting_charge_type.toLowerCase()}`;
                let price = buyable.renting_charge_amount
                if (this.orderItem) {
                    price = this.orderItem.price;
                }
                if (this.cartItem && this.cartItem.isSplitted) {
                    return this.getExchangedAmount(price * this.count);
                } else {
                    const startMoment = moment(this.start.replaceAll('/', '-'));
                    const endMoment = moment(this.end.replaceAll('/', '-'));
                    const billableUnits = (this.cartItem && this.cartItem.isSplitted) ? 1 : calculateBillableUnits(buyable, startMoment, endMoment);
                    return this.$t(translationKey, {
                        count: this.count, // for tc
                        price: this.getExchangedAmount(price * this.count * billableUnits),
                        billableUnits
                    });
                }
            } else {
                if (this.cartItem && this.cartItem.appliedPricingRule) {
                    return this.getExchangedAmount(this.cartItem.total);
                }
                return this.getExchangedAmount(buyable.price * this.count);
            }
        },
    },
    methods: {
        localizedAmount,
        getExchangedAmount(amount) {
            // if there's force currency means we just use the currency and the amount
            // no need to exchange
            if (this.forceCurrency) {
                return this.localizedAmount(amount, this.forceCurrency, this.currencyOptions);
            }
            // 如果沒有 forceCurrency，就要換算，從廠商的幣別換到使用者的幣別
            return getExchangedAmount({
                rateMap: this.currencyRateMap,
                amount,
                from: this.provider.currency || 'TWD',
                to: this.currency,
                currencyOptions: this.currencyOptions,
            });
        },
    }
}
</script>

<i18n>
{
    "en": {
        "price_per_hour": "{price} for {billableUnits} hour|{price} for {billableUnits} hours",
        "price_per_day": "{price} for {billableUnits} day|{price} for {billableUnits} days",
        "price_per_night": "{price} for {billableUnits} night|{price} for {billableUnits} nights",
        "price_per_booking": "{price}",
        "fail_to_get_price": "Fail to get price"
    },
    "zh": {
        "price_per_day": "{billableUnits} 天 {price}",
        "price_per_hour": "{billableUnits} 小時 {price}",
        "price_per_night": "{billableUnits} 晚 {price}",
        "price_per_booking": "{price}",
        "fail_to_get_price": "無法取得價格"
    }
}
</i18n>
